module.exports = __webpack_public_path__ + "static/media/modalLogin.95c1b790.svg";